<template>
    <div class="deal_refund_box">
        <!-- 交易密碼 -->
        <div class="deal_title">
            <div>個人資訊<span>》</span>交易密碼</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- BOX-go -->
        <div>
            <!-- 内容 -->
            <div class="deal_content_box">
                <div class="deal_content_title">修改交易密碼</div>
                <div class="deal_content">
					<div class="remind_box" v-show="succeedTF">
						<i class="el-icon-warning icon_warning"></i>
						您正在修改您的<span class="red_pass">交易密碼</span>，請輸入以下資訊後在送出更改申請。在商家平台執行敏感操作時，需要輸入交易密碼進行驗證，請牢記交易密碼。
                    </div>
					<div class="remind_box"  v-show="!succeedTF">
						<i class="el-icon-warning icon_warning"></i>
						設定完成。
                    </div>
                    <!-- 交易密碼 -->
                    <div class="pass_box" v-show="succeedTF">
                        <!-- 1-google驗證碼 -->
                        <div v-show=" passNumber == '1' ">
                            <span class="pass_red">*</span><span class="pass_red">google驗證碼</span>：
                            <el-input placeholder="" v-model="googleInput" ></el-input>
                            <span class="pass_blue"></span>
                        </div>
                        <!-- 2-交易密码 -->
                        <div  v-show=" passNumber == '2' ">
                            <span class="pass_red">*</span><span class="pass_red">簡訊驗證碼：</span>
                            <el-input placeholder="" v-model="oldInput" show-password maxlength='6'></el-input>
                            <span class="pass_blue">忘記交易密碼？</span>
                        </div>
                        <!-- 3-短信验证码 -->
                        <div  v-show=" passNumber == '3' ">
                            <span class="pass_red">*</span>手機<span class="pass_red">簡訊</span>驗證：
                            <el-input placeholder="請輸入手機簡訊驗證碼" v-model="phoneInput" maxlength='6'></el-input>
                            <el-button class="account_button" type="primary" @click="axiosVerification()" :disabled="disabledTF">{{buttonText}}</el-button>
                            <span class="pass_blue">沒有收到驗證碼？</span>
                        </div>
                        <!-- 预留资讯 -->
                        <div class="reserved_text">
                            預留資訊：<span class="pass_green">{{this.$store.state.reserved}}</span>
                        </div>
                        <div>
                            <span class="pass_red">*</span>新的<span class="pass_red">交易</span>密碼：
                            <el-input placeholder="" v-model="newInput" show-password maxlength='6' @blur="passVerifyFun()"></el-input>
                            <span v-show="!newInputTF" class="pass_red">{{newInputText}}</span>
                            <i v-show="newInputTF" class="el-icon-success pass_green"></i>
                        </div>
                        <div class="box_margin">
                            <span class="pass_red">*</span>重複<span class="pass_red">交易</span>密碼：
                            <el-input placeholder="" v-model="passInput" show-password maxlength='6' @blur="passTwoVerifyFun()"></el-input>
                            <span v-show="!passInputTF" class="pass_red">{{passInputText}}</span>
                            <i v-show="passInputTF" class="el-icon-success pass_green"></i>
                        </div>
                        <div class="pass_button">
                            <el-button plain @click="accountFun()">返回</el-button>
                            <el-button type="primary" @click="submitForm()">送出</el-button>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- BOX-end -->
        </div>
        <!-- deal_refund_box -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'loginat',
    data() {
        return {
            passNumber: '2',
            succeedTF: true,
            googleInput: '',
			timeto:60,
			countTime:60,
            oldInput: '',
            phoneInput: '',
            buttonText: '點擊發送驗證碼',
            message: '',
            status: '',
            VerMessage: '',
            VerStatus: '',
            disabledTF: false,
            newInput: '',
            newInputTF: false,
            newInputText: '交易密碼請勿與登入密碼相同',
            passInput: '',
            passInputTF: false,
            passInputText: '請重複輸入密碼',
        }
    },
    methods: {
        // 返回
        accountFun() {
            this.$router.push("/login/account");
        },
        // 点击发送短信验证
        axiosVerification() {
            axios.get(this.$store.state.axiosPhone, {
                params: {
                    telnum: this.$store.state.telephone
                }
            }).then((res) => {
                // console.log(res.data);
                this.VerMessage = res.data.message;
                this.VerStatus = res.data.status;
                this.disabledTF = true;
                this.verify = "已發送驗證碼";
                // 倒計時
                this.buttonText = this.timeto + "秒後，可再次發送";
                let count = setInterval(() => {
                    this.timeto -= 1;
                    this.buttonText = this.timeto + "秒後，可再次發送";
                    if (this.timeto < 0) {
                        clearInterval(count);
                        this.buttonText = '發送驗證碼';
                        this.timeto = this.countTime;
                        this.disabledTF = false;
                        return
                    }
                }, 1000);
            })
        },
        // FUN-新的交易密碼驗證：
        passVerifyFun(){
            if(this.newInput == ''){
                this.newInputText = '交易密碼請勿與登入密碼相同';
                this.newInputTF = false;
                return
            }
            if(this.newInput.length < 6){
                this.newInputText = '交易密碼必須為6位純數字，請重新輸入';
                this.newInputTF = false;
                return
            }
            let pattern = /\D/;
            if (!pattern.test(this.newInput)){
                // 輸入正確：
                this.newInputTF = true;
                this.passTwoVerifyFun();

            } else {
                this.newInputText = '交易密碼必須為純數字，請重新輸入';
                this.newInputTF = false;
            }
        },
        // FUN-重複密碼驗證：
        passTwoVerifyFun(){
            if(this.passInput == ''){
                this.passInputText = '請重複輸入密碼';
                this.passInputTF = false;
                return
            }
            if(this.newInputTF){
                if( this.newInput == this.passInput ){
                    // 重複密碼正確：
                    this.passInputTF = true;
                } else {
                    this.passInputText = '兩次輸入密碼不一致，請重新輸入';
                    this.passInputTF = false;
                }
            }
        },
        // 短信驗證碼：
        judgeVerification(){
            // 是否驗證碼：
            if(this.VerStatus){
                // 
                if(this.phoneInput == this.VerMessage){

                    this.judgeSubmit();
                } else {
                    // 錯誤提示：
                    this.$message({
                        showClose: true,
                        message: '驗證碼錯誤，請重新輸入',
                        type: 'error',
                        duration: 1000
                    });
                }

            } else {
                // 錯誤提示：
                this.$message({
                    showClose: true,
                    message: '請輸入驗證碼',
                    type: 'error',
                    duration: 1000
                });
            }

        },
        // FUN-提交送出
        submitForm(){
            // 手機驗證碼：
            if(this.passNumber == '3'){
                this.judgeVerification();
            } else {

                this.judgeSubmit();                
            }

            
        },
        // 判斷-提交送出：
        judgeSubmit(){

            if(this.newInputTF && this.passInputTF){

                axios.get(this.$store.state.axiossubmitPasstr, {
                    params: {
                        uid :this.$store.state.uid,
                        action:1,
                        secret: this.googleInput,
                        trader_password: this.oldInput,
                        re_password: this.newInput,
                    }
                }).then((res) => {
                    this.status = res.data.status;
                    this.message = res.data.message;
                    // console.log(res.data);
                    if (!this.status){			
                        if (this.status == -1){
                            this.$message({
                                showClose: true,
                                message: '交易密碼有誤，請重新輸入',
                                type: 'error',
                                duration: 1000
                            });
                        }else {
                            this.$message({
                                showClose: true,
                                message: this.message,
                                type: 'error',
                                duration: 1000
                            });
                        }
                    }else{
                        this.succeedTF = false;
                        this.googleInput = '';
                        this.oldInput = '';
                        this.newInput = '';
                        this.passInput = '';

                        // GOGOGO:
                        setTimeout(() =>{
                            this.succeedTF = true;
                        }, 1000)

                    }
                })

            }

        },

    },
    mounted() {
        
        // 判斷3重驗證中的哪個？
        // if(this.$store.state.secretTF != '-1'){
        //     this.passNumber = '1';
            
        // } else if(this.$store.state.traderPassTF != '-1'){
        //     this.passNumber = '2';

        // } else {
        //     this.passNumber = '3';
        // }

    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* API安全 */
    .input_box {
        width: 100px;
    }
    .textarea_box {
        width: 350px;
        margin-left: 10px;
    }
    .input_pass {
        width: 350px;
    }
    .input_pass_number {
        cursor: pointer;
        margin-left: 10px;
        color: #4d80e7;
    }
    .el-input__inner {
        height: 20px;
    }
    .deal_refund_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        margin: 30px 30px 30px 0;
        display: flex;
        justify-content: flex-start;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
        font-weight: 700;
    }
    .deal_content {
        box-sizing: border-box;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 5px 25px;
        min-height: 400px;
    }
    .deal_content > div {
        margin: 22px 0;
    }
    .deal_content > div > .left_span {
        margin-left: 68px;
    }
    .deal_content .money_box {
        margin-top: 22px;
        margin-left: 114px;
    }
    .deal_content .money_box span {
        padding: 0 20px;
    }
    .deal_content .money_box span+span {
        border-left: 1px solid ;
    }
    .refund_money {
        margin-left: 28px;
        margin-right: 20px;
    }
    .money_button {
        font-size: 11px;
        line-height: 11px;
        padding: 6px 14px;
    }
    .money_number {
        margin-left: 16px;
    }
    .money_number > span {
        color: #6ac259;
    }
    .textarea_dis {
        display: flex;
        justify-content: flex-start;
    }
    .hint {
        margin-left: 10px;
        margin-top: 8px;
        font-size: 9px;
        color: #666666;
    }
    .red_pass {
        color: #e73262;
    }
	/* 提示 */
	  .remind_box {
			background: #fff4cc;
			color: black;
			width: 70%;
			min-width: 686px;
			height: 50px;
			display: flex;
			align-items: center;
			margin-bottom: 30px;
			margin-left: -6px;
    }
		.icon_warning {
			font-size: 22px;
			color: #ff4a05;
			padding: 0 6px 0 24px;
    }
		.deal_content_box .pass_box {
			/* letter-spacing: 1px; */
            margin-left: 170px;
		} 
		.pass_box .pass_red {
			color: #e73262;
		}
		.pass_input {
			width: 280px;
		}
		.pass_box .pass_blue {
			color: #4d80e7;
			margin-left: 10px;
			cursor: pointer;
		}
        .pass_box .pass_green {
            color: #13ae22;
        }
        .pass_box .el-input {
            width: 280px;
            margin: 0 18px 0 12px;
        }
        .pass_box .el-select {
            width: 100px;
            margin: 0 0px 0 12px;
        }
        .reserved_text {
            margin: 18px 0px 56px 112px;
        }
        .box_margin {
            margin: 10px 0 20px 0;
        }
		.pass_button {
			padding: 8px;
            margin-left: 234px;

		}
/*  */
		.form_table_header {
			background: #f2f2f2;
			height: 34px;
			line-height: 34px;
			overflow: hidden;
		}
		.form_table_content {
			height: 34px;
			line-height: 34px;
		}
		.form_table_header span, .form_table_content span	{
			display: inline-block;
			padding-left: 20px; 
			width: 300px;
		}
		.button_add {
			width: 100px;
		}
		.button_margin {
			margin-left: 4px;
			margin-right: 30px;
		}
		.hint_text {
			color: #e73262;
			margin-top: 6px;
			height: 8px;
        }
</style>
